import React from "react"
import ReactSelect, { components } from "react-select"

import styles from "./Select.module.scss"

const { ValueContainer, Placeholder } = components

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  )
}

const Select = ({ options, loading, value, error, placeholder, onChange }) => {
  return (
    <div className={styles.wrapper}>
      <ReactSelect
        className={styles.select}
        classNamePrefix="select"
        isLoading={loading}
        options={options}
        value={value}
        placeholder={placeholder}
        isSearchable={false}
        components={{
          ValueContainer: CustomValueContainer,
        }}
        onChange={value => onChange(value)}
        styles={{
          placeholder: (provided, state) => ({
            ...provided,
            top:
              state.hasValue || state.selectProps.inputValue
                ? "0.2rem"
                : "1rem",
            fontSize:
              (state.hasValue || state.selectProps.inputValue) && "1.2rem",
            lineHeight:
              (state.hasValue || state.selectProps.inputValue) && "1.6rem",
          }),
          singleValue: (provided, state) => ({
            ...provided,
            top: (state.hasValue || state.selectProps.inputValue) && "1rem",
          }),
          input: (provided, state) => ({
            ...provided,
            top: (state.hasValue || state.selectProps.inputValue) && "1rem",
          }),
        }}
      />
      {error && <div className={styles.errorMsg}>{error}</div>}
    </div>
  )
}

export default Select
